import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ACCESS_TOKEN_KEY, USER_INFO_KEY } from "@app/constants";
import { clearUser } from "@app/store/auth/auth.action";
import StorageService from "@core/services/storage";

/** Đăng xuất như trước: xoá token và thông tin tài khoản rồi về trang đăng nhập. */
export default function useLogout() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  return () => {
    dispatch(clearUser());
    StorageService.remove(ACCESS_TOKEN_KEY);
    StorageService.remove(USER_INFO_KEY);
    navigate("/login");
  };
}
